import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=63027667&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=ts&"
export * from "./detail.vue?vue&type=script&lang=ts&"
import style0 from "./detail.vue?vue&type=style&index=0&id=63027667&prod&lang=scss&scoped=true&"
import style1 from "./detail.vue?vue&type=style&index=1&id=63027667&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63027667",
  null
  
)

export default component.exports